import { flatAdvanceForm } from "../../../helpers/advance-form.helper";

export function useForm27Validation() {
  const templateId = 27;
  enum TABLE_NAME {
    A = "รายการสินค้า",
    B = "ข้อมูลใบวางบิลสำหรับใช้ออกงบใบสำคัญ",
  }

  function validate(formData: any[]) {
    const data = flatAdvanceForm(formData)
      ?.filter((control) => {
        const template = control?.template;
        if (!template) {
          return false;
        }
        if (template.type == "tb" && template.label == TABLE_NAME.A) {
          return true;
        }
        if (template.type == "tb" && template.label == TABLE_NAME.B) {
          return true;
        }
      })
      .map((control: any) => {
        const label = control.template.label as TABLE_NAME;
        const columnName = {
          [TABLE_NAME.A]: ["หมวดวัสดุ", "มูลค่ารวมภาษีมูลค่าเพิ่ม"],
          [TABLE_NAME.B]: ["หมวดวัสดุ", "จำนวนเงิน"],
        }[label];
        const columns: { index: number; label: string }[] = (
          control.template.attribute.column || []
        )
          .map((column: any, i: number) => ({ index: i, label: column.label }))
          .filter((column: any) => columnName.includes(column.label));
        const data = (control.data.row || []).reduce(
          (acc: { [name: string]: number }, row: { value: string }[]) => {
            const values = row.map((r) => r.value);
            const category = values[columns[0].index];
            const value = parseFloat(values[columns[1].index]);
            return {
              ...acc,
              [category]: (acc[category] || 0) + value,
            };
          },
          {}
        );
        return { label, data };
      });
    const primary = data?.find((d) => d.label == TABLE_NAME.A);
    const secondary = data?.find((d) => d.label == TABLE_NAME.B);
    const primaryTotal = Object.keys(primary?.data).reduce((acc, key) => {
      acc += primary?.data[key];
      return acc;
    }, 0);
    const secondaryTotal = Object.keys(secondary?.data).reduce((acc, key) => {
      acc += secondary?.data[key];
      return acc;
    }, 0);
    // ปรับแก้ไขเงื่อนไขการตรวจสอบ วันที่ 2025-01-05 โดยแก้ให้สามารถ Submit ได้เมื่อมูลค่ารวมรายการใบวางบิลห่างกันไม่เกิน 1 บาท
    // by Peetisook S.
    if (Math.abs(primaryTotal - secondaryTotal) > 1.01) {
      return {
      valid: false,
      invalid: true,
      errors: {
        key: "มูลค่ารวม",
        message: "มูลค่ารวมรายการใบวางบิลไม่เท่ากับรายการสินค้า หรือ มูลค่ารวมรายการใบวางบิลห่างกันบาท 1 บาท",
      },
      };
    }
    return (
      Object.keys(primary?.data || {})
        .map((key) => {
          let message = null;
          // if (primary?.data[key] < secondary?.data[key]) {
          //   message = `มูลค่ารวมรายการใบวางบิลหมวดหมู่ ${key} มีมากกว่ารายการสินค้า`;
          // } else if (primary?.data[key] > secondary?.data[key]) {
          //   message = `มูลค่ารวมรายการใบวางบิลหมวดหมู่ ${key} มีน้อยกว่ารายการสินค้า`;
          // }
          return {
            valid: message == null,
            invalid: message != null,
            errors: {
              key,
              message,
            },
          };
        })
        .find((d) => d.invalid) ?? { valid: true, invalid: false, errors: null }
    );
  }

  return { templateId, validate };
}
